window.theme.block('hero-background-slider', el => {
    const blockId = el.dataset.blockId;
    const sliderHero = el.querySelector('.slider-hero');

    function togglePlayVideo(item, action) {
        const video = item.querySelector('video, iframe');
        const coverImage = item.querySelector('.js-cover-image');

        if (!video) return;

        const isVideo = video.tagName === 'VIDEO';
        const isPlaying = isVideo ? !video.paused : iframe.src.includes('autoplay=1');
        const videoUrl = !isVideo ? new URL(video?.dataset?.src || video.src) : false;

        if (isPlaying && action !== 'play') {
            videoUrl?.searchParams?.set('autoplay', 0);
            if (coverImage) {
                coverImage.classList.remove('is-hidden');
            }

            if (isVideo) {
                video.pause();
            }
        } else if (!isPlaying && action !== 'pause') {
            videoUrl?.searchParams?.set('autoplay', 1);
            if (coverImage) {
                coverImage.classList.add('is-hidden');
            }

            if (isVideo) {
                video.play();
            } else {
                video.src = videoUrl;
            }
        }
    }

    if (sliderHero) {
        new window.theme.packages.swiper(sliderHero, {
            slidesPerView: 1,
            effect: 'fade',
            autoHeight: false,
            navigation: {
                prevEl: `[data-block-id='${blockId}'] .js-prev`,
                nextEl: `[data-block-id='${blockId}'] .js-next`
            },
            on: {
                slideChange: function (swiper) {
                    swiper.slides.forEach(slide => {
                        togglePlayVideo(slide, 'pause');
                    });
                },
                slideChangeTransitionEnd: function (swiper) {
                    const activeSlide = swiper.slides[swiper.activeIndex];
                    togglePlayVideo(activeSlide, 'play');
                }
            }
        });

        // Trigger Video Modals
        const slides = sliderHero.querySelectorAll('.slide');
        slides.forEach(slide => {
            const playButton = slide.querySelector('.js-play-button');
            const modalButton = slide.querySelector('.video-player .js-modal-trigger');
            const video = slide.querySelector('.video-player video');
            const iframe = slide.querySelector('iframe');

            if (playButton) {
                playButton.addEventListener('click', e => {
                    e.preventDefault();

                    if (modalButton) {
                        modalButton.click();
                    }
                });
            } else if (video || iframe) {
                togglePlayVideo(slide);
            }
        });
    }
});
